import axios from "axios";

const $api = axios.create({
    baseURL: "https://importer.amo.tools"
})

export interface WorkProgressInterface {
    rowCount: number,
    passCount: number,
    startedAt: number,
    errors: ({ text: string, date: number })[]
}

export interface WorkProgressHistoryInterface {
    rowCount: number,
    passCount: number,
    startedAt: number,
    endedAt: number,
    errors: ({ text: string, date: number })[]
}

export function getSheetInfo (subdomain: string) {
    return $api.get<{item?: WorkProgressInterface}>("/api/v1/sheets?subdomain=" + subdomain)
}

export function getSheetHistory (subdomain: string) {
    return $api.get<{items: WorkProgressHistoryInterface[]}>("/api/v1/sheets/history?subdomain=" + subdomain)
}

export function startParse (payload: {
    "subdomain": string
    "email": string
    "apiKey": string
    "googleId": string
}) {
    return $api.post("/api/v1/sheets/parse", payload)
}

export default $api